import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function AirTableIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M10.5825 2.48272L1.74694 6.13871C1.2556 6.34205 1.26069 7.04008 1.75511 7.23606L10.6275 10.7545C11.4071 11.0637 12.2752 11.0637 13.0548 10.7545L21.9273 7.23592C22.4216 7.04008 22.4269 6.34219 21.9353 6.13885L13.1 2.48259C12.294 2.14903 11.3885 2.14903 10.5824 2.48259"
        fill="#FCB400"
      />
      <path
        d="M12.6284 12.676V21.4656C12.6284 21.8835 13.05 22.1699 13.4386 22.0159L23.3251 18.1784C23.4354 18.1347 23.53 18.0589 23.5966 17.9607C23.6633 17.8626 23.6989 17.7467 23.6989 17.6281V8.83862C23.6989 8.42055 23.2773 8.13429 22.8887 8.28834L13.0021 12.1258C12.8919 12.1696 12.7973 12.2454 12.7307 12.3435C12.6641 12.4416 12.6284 12.5574 12.6284 12.676Z"
        fill="#18BFFF"
      />
      <path
        d="M10.3195 13.1295L7.38539 14.5462L7.08748 14.6902L0.893738 17.6579C0.501254 17.8473 0 17.5612 0 17.125V8.87538C0 8.71759 0.0809079 8.58135 0.18941 8.47888C0.233923 8.43455 0.284422 8.39668 0.339438 8.36636C0.487323 8.27755 0.698433 8.25384 0.877931 8.32483L10.2702 12.0463C10.7476 12.2357 10.7851 12.9046 10.3195 13.1295Z"
        fill="#F82B60"
      />
      <path
        d="M10.3196 13.1295L7.38543 14.5462L0.189453 8.47875C0.233975 8.43447 0.284474 8.39664 0.339481 8.36636C0.487366 8.27755 0.698476 8.25384 0.877974 8.32483L10.2703 12.0463C10.7477 12.2357 10.7852 12.9046 10.3196 13.1295Z"
        fill="black"
        fillOpacity="0.25"
      />
    </svg>
  );
};
